export enum PaginationAtomsKeys {
    LensesList = "lensesList",
    LensFolderSubmission = "lensFoderSubmission",
    LensesInsightsHeader = "lensInsightsHeader",
    // Own key so the web-lens update picker's search/pagination never bleeds into the
    // Studio submission picker's (LensFolderSubmission) or the main list's state.
    WebLensUpdatePicker = "webLensUpdatePicker",
}
